<div *ngIf="prikaziStranicu" class="container-fluid">
  <h2 class="content-block">NALJEPNICE ZA ISPIS</h2>

  <div class="customTable nadzornaPloca tablicaNaljepnice m-40">
    <div id="data-grid-demo">
      <dx-data-grid
        [dataSource]="deklaracije"
        [wordWrapEnabled]="true"
        noDataText="{{ poruka }}"
        keyExpr="sifra"
        [showColumnLines]="true"
        [showBorders]="false"
        (onToolbarPreparing)="onToolbarPreparing($event)"
        (onCellPrepared)="onCellPrepared($event)">

        <div *dxTemplate="let data of 'naslovTablice'" class="grid-wrapper">
          <div class="naslov">
            <h2 class="mb-0">Palete</h2>
            <p class="mt-0">Pregled paleta i ispis naljepnica</p>
          </div>

          <dx-button
            class="nove-naljepnice"
            text="Ponovo kreiraj naljepnice za ispis"
            [disabled]="pravaZaTrenutniPogled != 2"
            (click)="noveNaljepnice()">
          </dx-button>
        </div>

        <div *dxTemplate="let data of 'odabirDatuma'">
          <div class="nadzornaDatum">
            <span>Datum</span>
            <dx-date-box
              applyValueMode="useButtons"
              pickerType="calendar"
              [value]="today"
              displayFormat='dd.MM.yyyy.'
              [acceptCustomValue]="true"
              [useMaskBehavior]="true"
              (onValueChanged)="promjenaDatuma($event)">
            </dx-date-box>
          </div>
        </div>

        <div *dxTemplate="let data of 'odabirSmjene'">
          <div class="selectDropdown">
            <span>Smjena</span>
            <dx-select-box
              [disabled]="false"
              [items]="smjene"
              [value]="smjene[0].id"
              valueExpr="id"
              displayExpr="naziv"
              [width]="120"
              (onValueChanged)="promjenaSmjene($event)">
            </dx-select-box>
          </div>
        </div>

        <dxo-search-panel
          [visible]="true"
          [width]="210"
          placeholder="Pretraži...">
        </dxo-search-panel>

        <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>

        <dxo-pager
          [showPageSizeSelector]="true"
          [allowedPageSizes]="[10, 20, 30]"
          [showInfo]="true">
        </dxo-pager>

        <dxi-column dataField="idArtikl" [visible]="false"></dxi-column>
        <dxi-column
          dataField="idPlan"
          caption="Plan"
          [width]="80"
          alignment="center">
        </dxi-column>
        <dxi-column
          dataField="datum"
          caption="Datum"
          [width]="110"
          alignment="center">
        </dxi-column>
        <dxi-column
          dataField="lot"
          caption="LOT"
          [width]="90"
          alignment="center">
        </dxi-column>
        <dxi-column
          dataField="sifra"
          caption="Šifra"
          [width]="90"
          alignment="center">
        </dxi-column>
        <dxi-column dataField="naziv" caption="Proizvod"></dxi-column>
        <dxi-column
          dataField="smjena"
          caption="Smjena"
          [width]="80"
          alignment="center">
        </dxi-column>
        <dxi-column
          dataField="vrstaNaljepnice"
          caption="Vrsta naljepnice"
          [width]="105"
          alignment="center">
        </dxi-column>
        <dxi-column
          dataField="kolicina"
          caption="Komada"
          [width]="100"
          alignment="center">
        </dxi-column>
        <dxi-column
          dataField="paleta"
          caption="Broj paleta"
          [width]="90"
          alignment="center">
        </dxi-column>
        <dxi-column
          dataField="kartona"
          caption="Broj kartona na paleti"
          [width]="100"
          alignment="center">
        </dxi-column>
        <dxi-column cellTemplate="uredjivanje" [width]="105" alignment="left">
          <div *dxTemplate="let data of 'uredjivanje'">
            <dx-button [disabled]="pravaZaTrenutniPogled != 2"
              icon="orderedlist"
              hint="Pogledaj palete"
              (onClick)="dohvatiPaleteData(data)">
            </dx-button>
            <dx-button [disabled]="pravaZaTrenutniPogled != 2"
              icon="print"
              hint="Ispis QR kodova"
              (onClick)="dohvatiPaleteZaIspis(data)">
            </dx-button>
          </div>
        </dxi-column>
      </dx-data-grid>
    </div>
  </div>

  <dx-popup
    [width]="750"
    [height]="'auto'"
    [showTitle]="true"
    title="Dodavanje naljepnica za ispis"
    [dragEnabled]="false"
    [closeOnOutsideClick]="false"
    [position]="{ my: 'top', at: 'center top', of: '', offset: '0 300' }"
    [(visible)]="popupDodajNoveNaljepniceZaIspisVisible">
    <div class="popup-form-wrapper">
      <div class="floating-placeholder">
        <dx-select-box
          contenteditable
          placeholder="Plan"
          displayExpr="idplan"
          valueExpr="idplan"
          [dataSource]="noviPlanovi"
          [(value)]="idPlan"
          [showClearButton]="true"
          [searchEnabled]="true"
          (onValueChanged)="onChangeIdPlan($event)"
          required>
        </dx-select-box>
      </div>

      <div class="floating-placeholder">
        <dx-select-box
          [showClearButton]="true"
          placeholder="Barkod"
          [searchEnabled]="true"
          [displayExpr]="displayExpression"
          [dataSource]="filtriraniBarkodovi"
          [(value)]="barkodArtikla"
          [disabled]="idPlan == null"
          (onValueChanged)="onChangeBarkodArtikla($event)"
          required>
        </dx-select-box>
      </div>

      <div class="floating-placeholder">
        <dx-text-box
          placeholder="Šifra artikla"
          [value]="sifraArtikla"
          [disabled]="!sifraArtiklaIsEmpty"
          required>
        </dx-text-box>
      </div>

      <div class="floating-placeholder">
        <dx-text-box
          placeholder="Naziv artikla"
          [value]="nazivArtikla"
          [disabled]="!nazivArtiklaIsEmpty"
          required>
        </dx-text-box>
      </div>

      <div class="floating-placeholder">
        <dx-text-box
          contenteditable
          placeholder="Količina u kartonu"
          [value]="kartonKolicina"
          [disabled]="!kartonKolicinaIsEmpty"
          (onValueChanged)="onChangeKolicinaKartona($event)"
          required>
        </dx-text-box>
      </div>

      <!-- <div class="floating-placeholder">
        <dx-check-box
          placeholder="Za narudžbu"
          [value]="zaNarudzbu"
          required
        ></dx-check-box>
      </div> -->

      <div class="floating-placeholder">
        <dx-text-box
          contenteditable
          placeholder="Količina kartona na paleti"
          [value]="kolicinaKartonaNaPaleti"
          [disabled]="!kolicinaKartonaNaPaletiIsEmpty"
          (onValueChanged)="onChangeKolicinaKartonaNaPaleti($event)"
          required>
        </dx-text-box>
      </div>

      <dx-button
        [width]="'auto'"
        [height]="'auto'"
        class="kreirajButton"
        stylingMode="outlined"
        type="success"
        text="Kreiraj"
        [disabled]="odabraniIdPlan === '' || odabraniBarkod === ''"
        (onClick)="spremiIzmjene()">
      </dx-button>

      <dx-button
        [width]="'auto'"
        [height]="'auto'"
        class="odustaniButton"
        stylingMode="outlined"
        style="
          color: red;
          border-color: red;
          background-color: white;
          cursor: pointer;
        "
        type="false"
        text="Odustani"
        (onClick)="odustaniOdIzmjena()">
      </dx-button>
    </div>
  </dx-popup>

  <dx-popup
    [width]="800"
    [height]="'auto'"
    [showTitle]="true"
    titleTemplate="customTitle"
    [dragEnabled]="false"
    [closeOnOutsideClick]="false"
    [position]="{ my: 'top', at: 'center top', of: '', offset: '0 100' }"
    [(visible)]="prikaziPaletePopupVisible">

    <div class="popupHeader" *dxTemplate="let data of 'customTitle'">
      <h6>{{ proizvod }}</h6>
      <dx-button
        class="dodajPaletu"
        icon="plus"
        stylingMode="outlined"
        type="success"
        hint="Dodaj paletu"
        (onClick)="dodajPaletuPopup()">
      </dx-button>
      <dx-button
        class="btnKodovi"
        icon="print"
        hint="QR kodovi"
        text="QR kodovi"
        stylingMode="outlined"
        type="success"
        (onClick)="qrCodes()">
      </dx-button>
      <dx-button class="closePopup" icon="close" (onClick)="closePopup()">
      </dx-button>
    </div>

    <dx-data-grid
      id="tablicaPaleta"
      [dataSource]="palete"
      [wordWrapEnabled]="true"
      [showColumnLines]="true"
      keyExpr="redniBroj"
      [showBorders]="false">
      <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>
      <dxi-column
        dataField="redniBroj"
        caption="RB."
        alignment="center">
      </dxi-column>
      <dxi-column
        dataField="brKartona"
        caption="Broj kartona"
        alignment="center">
      </dxi-column>
      <dxi-column
        dataField="brKomada"
        caption="Broj komada"
        alignment="center">
      </dxi-column>
      <dxi-column
        dataField="status"
        caption="Status"
        alignment="center">
      </dxi-column>
      <dxi-column
        dataField="dopunjeno"
        caption="Nadopunjeno"
        alignment="center">
      </dxi-column>
      <dxi-column
        dataField="ispisano"
        caption="Ispisano"
        alignment="center">
      </dxi-column>
      <dxi-column cellTemplate="urediPaletu" [width]="150" alignment="center">
        <div *dxTemplate="let data of 'urediPaletu'">
          <dx-button
            icon="edit"
            hint="Uredi paletu"
            [disabled]="data.data.vrstaPalete === 2"
            (onClick)="urediPaletuPopup(data)">
          </dx-button>
          <dx-button icon="print" hint="QR kod" (onClick)="qrCode(data)">
          </dx-button>
          <dx-button
            icon="trash"
            hint="Obriši paletu"
            [disabled]="data.data.vrstaPalete === 2"
            (onClick)="obrisiPaletuPopup(data)">
          </dx-button>
        </div>
      </dxi-column>
    </dx-data-grid>
  </dx-popup>

  <dx-popup
    [width]="700"
    [height]="'auto'"
    [showTitle]="true"
    title="{{ dodajUredi }}"
    [dragEnabled]="false"
    [closeOnOutsideClick]="false"
    [position]="{ my: 'top', at: 'center top', of: '', offset: '0 200' }"
    [(visible)]="dodajPaletuPopupVisible">
    <div class="dodajPaletuWrapper">
      <div class="field-wrapper">
        <label>Redni broj</label>
        <dx-number-box
          [value]="rBroj"
          placeholder="RB."
          (onValueChanged)="redniBrojChanged($event)">
        </dx-number-box>
      </div>
      <div class="field-wrapper">
        <label>Broj komada</label>
        <dx-number-box
          [value]="brKomada"
          placeholder="Unesite količinu"
          [max]="maxKomada"
          (onValueChanged)="brojKomadaChanged($event)">
        </dx-number-box>
      </div>
      <div class="field-wrapper">
        <label>Broj istih paleta</label>
        <dx-number-box
          [value]="brPaleta"
          placeholder="Unesite broj paleta"
          [max]="35"
          (onValueChanged)="brojPaletaChanged($event)">
        </dx-number-box>
      </div>
      <div class="field-wrapper">
        <label class="labelPolovicna">Polovična</label>
        <dx-check-box [disabled]="true" [value]="polovicna"> </dx-check-box>
      </div>
    </div>
    <div class="paletaMax">
      <p>*Maksimum broj komada na ovoj paleti je {{ maxKomada }}.</p>
    </div>
    <dx-button
      *ngIf="!idPalete"
      class="dodajButton"
      stylingMode="outlined"
      type="success"
      text="DODAJ"
      (onClick)="dodajPaletu()">
    </dx-button>
    <dx-button
      *ngIf="idPalete"
      class="dodajButton"
      stylingMode="outlined"
      type="success"
      text="SPREMI"
      (onClick)="urediPaletu()">
    </dx-button>
  </dx-popup>

  <dx-popup
    [width]="400"
    [height]="'auto'"
    [showTitle]="true"
    title="Obriši paletu"
    [dragEnabled]="false"
    [closeOnOutsideClick]="false"
    [position]="{ my: 'top', at: 'center top', of: '', offset: '0 300' }"
    [(visible)]="obrisiPaletuPopupVisible">
    <p>Jeste li sigurni da želite obrisati ovu paletu?</p>
    <dx-button
      class="dodajButton"
      stylingMode="outlined"
      type="success"
      text="DA"
      (onClick)="obrisiPaletu()">
    </dx-button>
    <dx-button
      class="dodajButton"
      stylingMode="outlined"
      type="danger"
      text="NE"
      (onClick)="obrisiPaletuPopupVisible = false">
    </dx-button>
  </dx-popup>
</div>
